export default {
  progress: '{0} z {1}',
};
